import React, { useEffect, useState } from 'react';
import { Check, FileText, Heart, Compass, AlertTriangle, Clock, BookOpen } from 'lucide-react';
import { Section } from './Shared';
import { Pricing } from './Pricing';
import { CandleFlame, TearDrop } from './SacredIcons';
const LaunchUrgency = () => {
  const [timeLeft, setTimeLeft] = useState({
    h: 23,
    m: 7,
    s: 57
  });
  const [spotsTaken, setSpotsTaken] = useState(() => {
    const saved = typeof window !== 'undefined' ? sessionStorage.getItem('kit-terapeuta-launch-spots') : null;
    if (saved) {
      const {
        value,
        timestamp
      } = JSON.parse(saved);
      const elapsed = (Date.now() - timestamp) / 1000;
      const increment = Math.floor(elapsed / 60);
      return Math.min(value + increment, 92);
    }
    return 68;
  });
  useEffect(() => {
    sessionStorage.setItem('kit-terapeuta-launch-spots', JSON.stringify({
      value: spotsTaken,
      timestamp: Date.now()
    }));
  }, [spotsTaken]);
  useEffect(() => {
    const id = setInterval(() => {
      setTimeLeft(prev => {
        let {
          h,
          m,
          s
        } = prev;
        if (s > 0) s--;else {
          s = 59;
          if (m > 0) m--;else {
            m = 59;
            if (h > 0) h--;
          }
        }
        return {
          h,
          m,
          s
        };
      });
    }, 1000);
    return () => clearInterval(id);
  }, []);
  useEffect(() => {
    const id = setInterval(() => {
      setSpotsTaken(prev => {
        if (prev >= 92) return prev;
        return Math.random() < 0.4 ? prev + 1 : prev;
      });
    }, 45000 + Math.random() * 30000);
    return () => clearInterval(id);
  }, []);
  const fmt = (n: number) => n.toString().padStart(2, '0');
  const TimeBox = ({
    value,
    label
  }: {
    value: number;
    label: string;
  }) => <div className="flex flex-col items-center" data-id="element-233">
      <div className="bg-brand-violet text-white font-mono font-bold text-2xl md:text-4xl rounded-xl px-3 md:px-5 py-2 md:py-3 min-w-[56px] md:min-w-[80px] text-center shadow-md tabular-nums border border-brand-goldLight/40" data-id="element-234">
        {fmt(value)}
      </div>
      <span className="text-[10px] md:text-xs font-medium text-brand-text/70 mt-1.5 uppercase tracking-wider" data-id="element-235">
        {label}
      </span>
    </div>;
  return <div className="max-w-4xl mx-auto mb-12" data-id="element-236">
      <div className="glass-panel rounded-3xl p-6 md:p-8 border-2 border-brand-gold/40 bg-gradient-to-br from-white/95 to-brand-goldLight/10 shadow-[0_10px_40px_rgba(201,169,97,0.12)]" data-id="element-237">
        <div className="flex items-center justify-center gap-2 mb-5" data-id="element-238">
          <Clock className="w-5 h-5 md:w-6 md:h-6 text-brand-goldDark shrink-0" data-id="element-239" />
          <h3 className="font-serif font-bold text-base md:text-xl text-brand-violetDark text-center" data-id="element-240">
            ⏰ PRECIO DE LANZAMIENTO — CIERRA EN:
          </h3>
        </div>

        <div className="flex items-center justify-center gap-2 md:gap-4 mb-5" data-id="element-241">
          <TimeBox value={timeLeft.h} label="Horas" data-id="element-242" />
          <span className="text-2xl md:text-4xl font-bold text-brand-gold/60 pb-5" data-id="element-243">
            :
          </span>
          <TimeBox value={timeLeft.m} label="Min" data-id="element-244" />
          <span className="text-2xl md:text-4xl font-bold text-brand-gold/60 pb-5" data-id="element-245">
            :
          </span>
          <TimeBox value={timeLeft.s} label="Seg" data-id="element-246" />
        </div>

        <div className="flex items-center justify-center gap-2 bg-amber-50 border border-amber-300/60 rounded-xl px-4 py-3 mb-6" data-id="element-247">
          <AlertTriangle className="w-4 h-4 md:w-5 md:h-5 text-amber-600 shrink-0" data-id="element-248" />
          <p className="text-sm md:text-base font-semibold text-amber-900 text-center" data-id="element-249">
            Después sube $10.000 ARS.{' '}
            <span className="text-brand-violet" data-id="element-250">No vuelve.</span>
          </p>
        </div>

        <div className="bg-white/80 rounded-2xl p-4 md:p-5 border border-brand-gold/30" data-id="element-251">
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-1 mb-3" data-id="element-252">
            <div className="flex items-center gap-2" data-id="element-253">
              <span className="relative flex h-2.5 w-2.5" data-id="element-254">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-brand-burgundy opacity-75" data-id="element-255"></span>
                <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-brand-burgundy" data-id="element-256"></span>
              </span>
              <span className="font-semibold text-sm md:text-base text-brand-text" data-id="element-257">
                Cupos al precio de lanzamiento
              </span>
            </div>
            <span className="text-xs md:text-sm font-bold text-brand-violet uppercase tracking-wide" data-id="element-258">
              Quedan pocos
            </span>
          </div>

          <div className="w-full bg-brand-gold/15 rounded-full h-2.5 overflow-hidden mb-2" data-id="element-259">
            <div className="bg-gradient-to-r from-brand-gold to-brand-goldDark h-2.5 rounded-full transition-all duration-1000 ease-out" style={{
            width: `${spotsTaken}%`
          }} data-id="element-260" />
          </div>

          <p className="text-xs md:text-sm text-brand-text/70 text-center" data-id="element-261">
            <strong className="text-brand-violet" data-id="element-262">{spotsTaken}%</strong> de los
            cupos al precio de lanzamiento ya tomados
          </p>
        </div>
      </div>
    </div>;
};
const libroPrincipal = {
  title: 'KIT TERAPEUTA PRO™',
  tagline: 'Sistema completo de organización terapéutica.',
  cover: 'https://cdn.magicpatterns.com/uploads/1kjhaqQ2yK5s2EzvccZE43/portada_Kit_principal.png',
  color: 'text-brand-violetDark',
  bgColor: 'bg-brand-violetDark/5',
  borderColor: 'border-brand-violetDark/20',
  bullets: ['Agenda Terapéutica: Tu tiempo, organizado con intención', 'Fichas Clínicas: Historial completo de cada paciente', 'Registro de Sesiones: Exactamente qué trabajaste y cuándo', 'Seguimiento Terapéutico: Sin que ningún caso quede en el aire', 'Objetivos Mensuales: Claridad sobre a dónde vas', 'Control de Avances: Métricas reales de tu crecimiento']
};
const bonuses = [{
  icon: Heart,
  title: 'DIARIO DEL TERAPEUTA™',
  desc: 'Espacio personal para registrar ideas, aprendizajes y crecimiento profesional.',
  cover: 'https://cdn.magicpatterns.com/uploads/jRhzmL1pdgxkgD2W2KbQP2/portada_bono_1..png',
  color: 'text-brand-violet',
  bgColor: 'bg-brand-violet/10',
  borderColor: 'border-brand-violet/30',
  price: '$10.000'
}, {
  icon: FileText,
  title: 'AGENDA DE SEGUIMIENTO™',
  desc: 'Para que ningún paciente quede sin continuidad.',
  cover: 'https://cdn.magicpatterns.com/uploads/31F5SpGFojQ3g6yDo55SfR/portada_bono_2..png',
  color: 'text-brand-burgundy',
  bgColor: 'bg-brand-burgundy/10',
  borderColor: 'border-brand-burgundy/30',
  price: '$10.000'
}, {
  icon: Compass,
  title: 'PLANIFICADOR TERAPÉUTICO™',
  desc: 'Objetivos, planificación mensual y crecimiento profesional.',
  cover: 'https://cdn.magicpatterns.com/uploads/iiCgodQFPyHd3aw99AhMb7/portada_bono_3.png',
  color: 'text-brand-goldDark',
  bgColor: 'bg-brand-gold/10',
  borderColor: 'border-brand-gold/30',
  price: '$10.000'
}];
const maestriaCover = 'https://cdn.magicpatterns.com/uploads/cCVkLtfh2BjHbC4QfGXKwU/Marketing_consiente_para_terapeutas.png';
const planComparison = [{
  situation: 'Un paciente cancela a último momento',
  without: 'Perdés el turno y el dinero',
  with: 'Reglas claras y encuadre de cobro anticipado'
}, {
  situation: 'No sabés cuánto cobrar por tu sesión',
  without: 'Cobrás menos por miedo a perder pacientes',
  with: 'Estructura de honorarios rentable y segura'
}, {
  situation: 'Pacientes que no se comprometen',
  without: 'Te frustrás y sentís que es tu culpa',
  with: 'Filtro de pacientes y contrato terapéutico'
}, {
  situation: 'Querés vivir 100% de tu práctica',
  without: 'Tenés otro trabajo para sostenerte',
  with: 'Plan de crecimiento a 90 días'
}, {
  situation: 'Desorden administrativo a fin de mes',
  without: 'No sabés cuánto ganaste realmente',
  with: 'Sistema financiero simple para terapeutas'
}];
export const MethodOverview = () => {
  return <Section id="method" className="relative" data-id="element-263">
      {/* Decorative Sacred elements */}
      <CandleFlame className="hidden lg:block absolute top-20 right-[3%] w-8 h-12 opacity-25 animate-float-soft" style={{
      transform: 'rotate(-15deg)'
    }} data-id="element-264" />
      <TearDrop className="hidden lg:block absolute top-60 left-[2%] w-10 h-12 opacity-30 animate-float-soft" style={{
      transform: 'rotate(12deg)',
      animationDelay: '1.5s'
    }} data-id="element-265" />

      {/* Compact header + mockup */}
      <div className="max-w-4xl mx-auto mb-5 md:mb-6" data-id="element-266">
        <div className="text-center mb-2.5 md:mb-3" data-id="element-267">
          <div className="inline-flex items-center space-x-1.5 bg-white border border-brand-gold/40 px-3 py-0.5 rounded-full mb-1.5 shadow-sm" data-id="element-268">
            <span className="text-sm" data-id="element-269">🏆</span>
            <span className="font-serif font-semibold tracking-wider text-brand-violetDark text-[10px] md:text-xs" data-id="element-270">
              PRESENTAMOS:
            </span>
          </div>
          <h2 className="text-lg md:text-3xl font-display font-bold leading-tight text-brand-violetDark mb-0.5" data-id="element-271">
            KIT TERAPEUTA PRO™
          </h2>
          <p className="text-brand-text/70 text-[11px] md:text-sm max-w-xl mx-auto" data-id="element-272">
            El primer sistema profesional diseñado específicamente para
            terapeutas holísticos que quieren organizar su consulta, dar
            seguimiento real a sus pacientes y crecer con claridad.
          </p>
        </div>

        <div className="relative z-10 w-full max-w-[220px] sm:max-w-[280px] md:max-w-sm mx-auto flex justify-center" data-id="element-273">
          <img src="https://cdn.magicpatterns.com/uploads/1kjhaqQ2yK5s2EzvccZE43/portada_Kit_principal.png" alt="Kit Terapeuta PRO™" className="w-full h-auto rounded-xl drop-shadow-2xl" draggable={false} data-id="element-274" />
        </div>
      </div>

      <div className="max-w-4xl mx-auto mb-8" data-id="element-275">
        <div className="space-y-3 md:space-y-4" data-id="element-276">
          {/* Libro Principal Card */}
          <div className={`rounded-xl p-4 md:p-6 border ${libroPrincipal.bgColor} ${libroPrincipal.borderColor} backdrop-blur-sm shadow-sm`} data-id="element-277">
            <div className="flex flex-col md:flex-row items-center gap-4 md:gap-8" data-id="element-278">
              <div className="shrink-0 w-32 sm:w-40 md:w-48" data-id="element-279">
                <img src={libroPrincipal.cover} alt={libroPrincipal.title} className="w-full h-auto rounded-md shadow-lg" draggable={false} data-id="element-280" />
              </div>

              <div className="flex-grow min-w-0 text-center md:text-left" data-id="element-281">
                <div className={`inline-block text-[10px] md:text-xs font-mono font-bold ${libroPrincipal.color} ${libroPrincipal.bgColor} border ${libroPrincipal.borderColor} px-2 py-0.5 rounded mb-2`} data-id="element-282">
                  📘 PLANIFICADOR PRINCIPAL
                </div>
                <h4 className="font-serif font-bold mb-1 text-base md:text-xl text-brand-violetDark leading-tight" data-id="element-283">
                  {libroPrincipal.title}
                </h4>
                <p className="text-brand-text/80 italic mb-4 text-xs md:text-base leading-snug" data-id="element-284">
                  {libroPrincipal.tagline}
                </p>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-2 text-xs md:text-sm text-brand-text/85 text-left" data-id="element-285">
                  {libroPrincipal.bullets.map((bullet, j) => <div key={j} className="flex items-start" data-id="element-286">
                      <Check className={`w-4 h-4 mr-2 mt-0.5 shrink-0 ${libroPrincipal.color}`} data-id="element-287" />
                      <span className="leading-snug" data-id="element-288">{bullet}</span>
                    </div>)}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="text-center mb-4 mt-10" data-id="element-289">
          <h3 className="text-lg md:text-xl font-serif font-bold text-brand-violetDark" data-id="element-290">
            🎁 3 BONOS ESTRATÉGICOS INCLUIDOS GRATIS
          </h3>
          <p className="text-[10px] md:text-xs uppercase tracking-wider text-brand-goldDark mt-0.5 font-bold" data-id="element-291">
            No son relleno. Son las tres piezas que completan el sistema.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-292">
          {bonuses.map((bonus, i) => {
          const Icon = bonus.icon;
          return <div key={i} className="glass-panel rounded-xl p-4 border-brand-gold/30 relative bg-white/90 flex items-start gap-3" data-id="element-293">
                <div className="shrink-0 w-20 sm:w-24" data-id="element-294">
                  <img src={bonus.cover} alt={bonus.title} className="w-full h-auto rounded-md shadow-md" draggable={false} data-id="element-295" />
                </div>
                <div className="flex-grow min-w-0" data-id="element-296">
                  <div className="flex items-center gap-2 mb-1" data-id="element-297">
                    <div className={`${bonus.bgColor} ${bonus.color} rounded-md p-1 shrink-0`} data-id="element-298">
                      <Icon className="w-3.5 h-3.5" data-id="element-299" />
                    </div>
                    <span className="bg-brand-goldDark text-white text-[10px] font-bold px-2 py-0.5 rounded shrink-0" data-id="element-300">
                      GRATIS
                    </span>
                  </div>
                  <h4 className="text-sm md:text-base font-serif font-bold text-brand-text leading-tight mb-1" data-id="element-301">
                    {bonus.title}
                  </h4>
                  <p className="text-xs text-brand-text/70 leading-snug mb-1.5" data-id="element-302">
                    {bonus.desc}
                  </p>
                  <p className="text-[11px] text-brand-text/50" data-id="element-303">
                    <span className="line-through" data-id="element-304">{bonus.price}</span>
                    <span className="ml-1.5 font-semibold text-brand-goldDark" data-id="element-305">
                      → Incluido
                    </span>
                  </p>
                </div>
              </div>;
        })}
        </div>

        <div className="text-center mt-5" data-id="element-306">
          <div className="inline-block glass-panel px-5 py-2 rounded-full border-brand-gold/30 bg-white/80" data-id="element-307">
            <p className="text-xs md:text-sm font-medium text-brand-text/80" data-id="element-308">
              Valor total bonos{' '}
              <span className="line-through text-brand-text/50" data-id="element-309">$30.000</span>{' '}
              <span className="text-brand-violet font-bold" data-id="element-310">
                → GRATIS con tu Kit
              </span>
            </p>
          </div>
        </div>
      </div>

      {/* Maestría / Marketing Consciente Upsell — entre bonos y precio de lanzamiento */}
      <div className="max-w-5xl mx-auto mb-8 mt-2" data-id="element-311">
        <div className="bg-white rounded-2xl p-5 md:p-8 border border-brand-gold/30 shadow-sm" data-id="element-312">
          <div className="relative z-10 w-full max-w-[220px] sm:max-w-[260px] mx-auto mb-5" data-id="element-313">
            <img src={maestriaCover} alt="Mentoría de Crecimiento™ — Upsell exclusivo" className="w-full h-auto rounded-xl shadow-lg ring-1 ring-brand-gold/30" draggable={false} data-id="element-314" />
          </div>
          <p className="text-base md:text-xl font-serif font-bold text-brand-violetDark mb-6 text-center" data-id="element-315">
            🎓 MARKETING CONSCIENTE PARA TERAPEUTAS™
          </p>
          <p className="text-center text-brand-text/80 text-sm mb-6" data-id="element-316">
            Organizar tu consulta es solo la mitad del camino. La otra mitad es
            que más personas descubran tu trabajo.
          </p>

          <div className="hidden md:block" data-id="element-317">
            <div className="grid grid-cols-3 gap-4 text-[11px] font-semibold uppercase tracking-wide text-brand-text/60 border-b border-brand-gold/20 pb-3 mb-3" data-id="element-318">
              <div data-id="element-319">Situación</div>
              <div className="text-brand-burgundy" data-id="element-320">
                ❌ SIN MARKETING CONSCIENTE
              </div>
              <div className="text-brand-violet" data-id="element-321">
                ✅ CON MARKETING CONSCIENTE
              </div>
            </div>
            <div className="space-y-3" data-id="element-322">
              {planComparison.map((row, i) => <div key={i} className="grid grid-cols-3 gap-4 text-xs md:text-sm text-brand-text/80 py-2 border-b border-brand-gold/10 last:border-0" data-id="element-323">
                  <div className="font-medium pr-4" data-id="element-324">{row.situation}</div>
                  <div className="text-brand-burgundy/80 pr-4" data-id="element-325">
                    {row.without}
                  </div>
                  <div className="text-brand-violet font-medium" data-id="element-326">
                    {row.with}
                  </div>
                </div>)}
            </div>
          </div>

          <div className="md:hidden space-y-4" data-id="element-327">
            {planComparison.map((row, i) => <div key={i} className="border-b border-brand-gold/15 pb-4 last:border-0 last:pb-0" data-id="element-328">
                <p className="text-sm font-semibold text-brand-text mb-2" data-id="element-329">
                  {row.situation}
                </p>
                <div className="text-xs text-brand-burgundy/80 mb-1" data-id="element-330">
                  ❌ {row.without}
                </div>
                <div className="text-xs text-brand-violet font-medium" data-id="element-331">
                  ✅ {row.with}
                </div>
              </div>)}
          </div>

          <p className="text-sm md:text-base font-medium text-brand-goldDark italic text-center mt-8" data-id="element-332">
            💡 Un solo paciente nuevo puede recuperar la inversión completa. Y
            este sistema te enseña a atraer muchos más.
          </p>
        </div>
      </div>

      <LaunchUrgency data-id="element-333" />

      <Pricing data-id="element-334" />
    </Section>;
};